import {
  HUD_STATS_PROP_LBL_CLR_MAP,
  HUD_STATS_PROPS,
} from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import StatProgressBar from "@/src/components/CommonCharts/StatProgressBar";
import { isA23 } from "../Stats";

export const ShowdownDetails = ({ hudStats }) => {
  if (!hudStats || Object.keys(hudStats).length === 0) return null;
  return (
    <div
      className={`flex flex-col ${styles.coreCardConfigBkGradient} ${
        isA23 ? "" : styles.coreCardAddaShadow
      } gap-[6px] mt-[12px] p-3`}
    >
      <div className="flex">
        <StatProgressBar
          labelLeft={HUD_STATS_PROP_LBL_CLR_MAP[HUD_STATS_PROPS.WTSD].label}
          value={hudStats?.[HUD_STATS_PROPS.WTSD]}
          labelRight={HUD_STATS_PROP_LBL_CLR_MAP[HUD_STATS_PROPS.WSD].label}
          valueRight={hudStats?.[HUD_STATS_PROPS.WSD]}
          variant="double"
        />
      </div>
    </div>
  );
};
